import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzTableFilterComponent } from "ng-zorro-antd/table";
import { UiTableFilterList } from "@webapp/ui/table/table.models";

@Component({
  selector: "ui-table-filter",
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "filter.component.html",
})
export class UiTableFilterComponent extends NzTableFilterComponent {
  @Input("contentTemplate") public contentTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("customFilter") public customFilter = false;
  @Input("extraTemplate") public extraTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("filterMultiple") public filterMultiple = true;
  @Input("listOfFilter") public listOfFilter: UiTableFilterList = [];
  @Output("filterChange") public readonly filterChange = new EventEmitter<NzSafeAny[] | NzSafeAny>();
}
